(function () {

    function formatDate(days) {

        const date = new Date();

        date.setDate(
            date.getDate() + Number(days)
        );

        const day =
            String(date.getDate()).padStart(2, '0');

        const month =
            String(date.getMonth() + 1).padStart(2, '0');

        return `${day}/${month}`;
    }


    function getProductForm() {

        return document.querySelector(
            '#product-form form[data-type="add-to-cart-form"]'
        );
    }


    function getCurrentVariantId() {

        const form = getProductForm();

        if (!form) return null;

        const input =
            form.querySelector('input[name="id"]');

        return input
            ? Number(input.value)
            : null;
    }

    function hasFordeerPreorder() {
        return !!document.querySelector(
            '.bss-po-product-page'
        );
    }


    function getPreorderVariant(variantId) {

        const dataElement =
            document.getElementById('preorder-variants');

        if (!dataElement || !variantId) {
            return null;
        }

        try {

            const variants =
                JSON.parse(
                    dataElement.textContent || '[]'
                );

            return variants.find(
                variant =>
                    Number(variant.id) ===
                    Number(variantId)
            );

        } catch (error) {

            console.error(
                '[Preorder] Cannot parse preorder variants:',
                error
            );

            return null;
        }
    }


    /*
     * =====================================================
     * SYNC PREORDER PROPERTIES
     * =====================================================
     */

    function updateLineItemProperties(variant) {
        if (!variant) return;

        const form = document.querySelector(
            '#product-form form[data-type="add-to-cart-form"]'
        );

        if (!form) return;

        const statusInput = form.querySelector(
            '#line-item-status'
        );

        const dispatchInput = form.querySelector(
            '#line-item-dispatch'
        );

        if (!statusInput || !dispatchInput) return;

        if (hasFordeerPreorder()) {
            return;
        }

        const start = Number(variant.start || 0);
        const end = Number(variant.end || 0);

        if (start > 0 && end > 0) {

            statusInput.value = 'Hàng đặt trước';

            dispatchInput.value =
                `${formatDate(start)} - ${formatDate(end)}`;

        } else {

            statusInput.value = '';
            dispatchInput.value = '';
        }
    }


    /*
     * =====================================================
     * FORCE SYNC BEFORE ADD TO CART
     * =====================================================
     */

    function syncBeforeAddToCart() {

        const variantId =
            getCurrentVariantId();

        if (!variantId) {
            return;
        }

        const variant =
            getPreorderVariant(
                variantId
            );

        updateLineItemProperties(
            variant
        );
    }


    /*
     * =====================================================
     * BUTTON TEXT
     * =====================================================
     */

    function updateButtonText(variant) {

        if (!variant) return;

        const button =
            document.querySelector(
                '#product-form button[type="submit"][name="add"]'
            );

        if (!button) return;

        const text =
            button.querySelector(
                '.hidden-loading'
            );

        if (!text) return;

        const start =
            Number(variant.start || 0);

        const end =
            Number(variant.end || 0);


        if (
            start > 0 &&
            end > 0
        ) {

            text.textContent =
                'Hàng đặt trước';

        }
    }


    /*
     * =====================================================
     * RENDER
     * =====================================================
     */

    function render() {

        const box =
            document.getElementById(
                'preorder-dispatch'
            );

        const variantId =
            getCurrentVariantId();


        if (!variantId) {

            if (box) {

                box.style.display =
                    'none';

                box.innerHTML =
                    '';
            }

            return;
        }


        const variant =
            getPreorderVariant(
                variantId
            );

        updateLineItemProperties(
            variant
        );


        if (!variant) {

            if (box) {

                box.style.display =
                    'none';

                box.innerHTML =
                    '';
            }

            return;
        }


        updateButtonText(
            variant
        );


        const start =
            Number(variant.start || 0);

        const end =
            Number(variant.end || 0);


        if (!box) return;


        if (
            start === 0 ||
            end === 0
        ) {

            box.style.display =
                'none';

            box.innerHTML =
                '';

            return;
        }


        box.style.display =
            '';


        box.innerHTML = `
            <div class="preorder-shipping">

                Hàng đặt trước

                <svg
                    viewBox="0 0 15 15"
                    fill="none"
                >
                    <path
                        d="M6.25501 7.69L6.31801 7.5L6.25501 7.31L5.76801 5.849L8.51901 7.5L5.76801 9.151L6.25501 7.69Z"
                        fill="currentColor"
                    />
                </svg>

                Dự kiến gửi từ

                <strong>
                    ${formatDate(start)}
                    -
                    ${formatDate(end)}
                </strong>

            </div>
        `;
    }


    /*
     * =====================================================
     * INIT
     * =====================================================
     */

    function init() {

        render();


        /*
         * Umino swatch
         */

        document.addEventListener(
            'click',
            function (event) {

                const swatch =
                    event.target.closest(
                        '.bls__option-swatch'
                    );

                if (!swatch) return;


                setTimeout(
                    render,
                    50
                );

                setTimeout(
                    render,
                    150
                );

                setTimeout(
                    render,
                    300
                );
            }
        );


        /*
         * Variant ID change
         */

        document.addEventListener(
            'change',
            function (event) {

                if (
                    event.target.matches(
                        '#product-form input[name="id"]'
                    )
                ) {

                    render();
                }
            }
        );


        /*
         * Umino variant event
         */

        document.addEventListener(
            'variant:change',
            function () {

                setTimeout(
                    render,
                    50
                );

                setTimeout(
                    render,
                    150
                );
            }
        );


        /*
         * =================================================
         * MOST IMPORTANT
         *
         * Capture click BEFORE BSS/Umino handlers.
         * =================================================
         */

        document.addEventListener(
            'click',
            function (event) {

                const button =
                    event.target.closest(
                        '#product-form button[name="add"]'
                    );

                if (!button) {
                    return;
                }


                /*
                 * Sync hidden properties immediately
                 * before theme/app processes the click.
                 */

                syncBeforeAddToCart();


                console.log(
                    '[Preorder] BEFORE ADD CART',
                    {
                        variantId:
                            getCurrentVariantId(),

                        status:
                            document
                                .querySelector(
                                    '#line-item-status'
                                )
                                ?.value,

                        dispatch:
                            document
                                .querySelector(
                                    '#line-item-dispatch'
                                )
                                ?.value
                    }
                );

            },
            true
        );

        document.addEventListener(
            'submit',
            function (event) {

                const form =
                    event.target.closest(
                        'form[data-type="add-to-cart-form"]'
                    );

                if (!form) {
                    return;
                }

                syncBeforeAddToCart();

            },
            true
        );
    }


    if (
        document.readyState ===
        'loading'
    ) {

        document.addEventListener(
            'DOMContentLoaded',
            init
        );

    } else {

        init();
    }

})();

